export default __webpack_public_path__ + "static/media/givingefficiency.1a3d088c.jpg";